import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        wrapper: {
            marginTop: "3.23vh"
        },
        card: {
            width: "100%",
            height: "144.15vw",
            backgroundColor: Color.White
        }
    },
    desktop: {
        wrapper: {
            marginTop: "0"
        },
        card: {
            height: "68.27vw"
        }
    }
};

export const InvoiceLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;

    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }

    return (
        <div style={loaderStyles.wrapper}>
            <div style={loaderStyles.card}>
                <ContentLoader
                    speed={1}
                    width={"100%"}
                    height={loaderStyles.card.height}
                    backgroundColor={Color.LoaderBackground}
                    foregroundColor={Color.LoaderForeground}
                >
                    {isMobile ? <>
                        <rect x="0%" y="0%" rx="5" ry="5" width="29.62%" height="5%"/>
                        <rect x="34.45%" y="0.78%" rx="5" ry="5" width="30.34%" height="3.78%"/>
                        <rect x="68.92%" y="0%" rx="8" ry="8" width="30.57%" height="5%"/>
                        <rect x="0%" y="9.55%" rx="10" ry="10" width="100%" height="88.78%"/>
                    </> 
                    : <>
                        <rect x="0%" y="0%" rx="0" ry="0" width="98.89%" height="100%"/>
                    </>}                     
                </ContentLoader>
            </div>
        </div>
    );
}